import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium';
import ConfirmationUnlinkTableDialog from 'components/ui/feedback/ConfirmationGridUnlink';
import { IsTenantAdministrator } from 'shared/permissions/IsTenantAdministrator';
import toast from 'shared/utils/toast';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { DataGridCell } from 'components/cells';
import { filterOperators } from 'components/enhanced';

export function ExamsCostsColumns(service: any, productId?: number, refresh?: any): GridColDef[] {
  const { t } = useTranslation();
  const translationPrefix = 'entities.exam';

  const columns: GridColDef[] = [
    {
      field: 'code',
      headerName: t(`${translationPrefix}.code`),
      width: 150,
      filterOperators,
      renderCell: (params: GridRenderCellParams) => {
        const supplier = params.row;
        return (
          <div>
            <Link to={`/tenant/cost-analysis/exams/${supplier.id}`}>
              <b className="text-secondary-500">{supplier.code}</b>
            </Link>
          </div>
        );
      }
    }
  ];

  ['workstations'].forEach((field) => {
    columns.push({
      field: field,
      width: 150,
      headerName: t(`global.workstations`),
      valueFormatter: ({ value }) => {
        const values = value.map((value) => value.code);
        return values.join(', ');
      },
      filterOperators: filterOperators,
      renderCell: (params: GridRenderCellParams) => {
        const value = params.value.map((value) => value.code);
        return <DataGridCell content={value ? value.join(',') : ''} />;
      }
    });
  });

  ['description', 'category', 'code_loinc', 'regional_code'].forEach((field) => {
    columns.push({
      field: field,
      width: 150,
      headerName: t(`${translationPrefix}.${field}`),
      filterOperators: filterOperators,
      renderCell: (params: GridRenderCellParams) => {
        return <DataGridCell content={params.value} />;
      }
    });
  });

  // Macro exams column
  columns.push({
    field: 'macro_exams',
    width: 150,
    filterOperators: filterOperators,
    headerName: t(`${translationPrefix}.macro_exams`),
    renderCell: (params: GridRenderCellParams) => {
      const value = params.value.map((value) => value.code);
      return <DataGridCell content={value ? value.join(',') : ''} />;
    }
  });

  if (productId) {
    columns.push({
      field: 'actions',
      type: 'actions',
      headerName: t(`global.actions`),
      getActions: (params) => [
        <IsTenantAdministrator key={123}>
          <ConfirmationUnlinkTableDialog
            id={+params.row.id}
            handleUnlink={(id) => {
              service.removeExam(productId, id).then(() => {
                toast.success(t('actions.successfully.unlinked'));
                if (refresh) refresh.current();
              });
            }}
          />
        </IsTenantAdministrator>
      ]
    } as GridColDef);
  }

  return columns;
}
